import { appRoutes, foremanRoute } from '@utils/consts';
import { foremanSharedRoutes } from '../shared/routes';

export const foremanSearchRoutes = [
  {
    path: foremanRoute.search,
    children: [
      {
        path: appRoutes.base,
        lazy: async () => {
          const { ForemanSearch } = await import('@pages/foreman/search');
          return {
            Component: () => <ForemanSearch />,
          };
        },
      },
      foremanSharedRoutes,
    ],
  },
];
